const STORAGE_KEY = 'productComparisonList';
const MAX_PRODUCTS = 3;

function getComparisonList() {
    try {
        const data = sessionStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch (error) {
        console.error('Error reading comparison list:', error);
        return [];
    }
}

function saveComparisonList(products) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(products));

        // Dispatch custom event for other pages to listen
        window.dispatchEvent(
            new CustomEvent('comparisonListUpdated', {
                detail: { products },
            })
        );
        return true;
    } catch (error) {
        console.error('Error saving comparison list:', error);
        return false;
    }
}

function addToComparison(productData) {
    let products = getComparisonList();
    const existingIndex = products.findIndex((p) => p.id === productData.id);

    if (existingIndex !== -1) {
        products = products.filter((p) => p.id !== productData.id);
        saveComparisonList(products);
        return { success: false, alreadyAdded: true, productCount: products.length };
    }

    if (products.length >= MAX_PRODUCTS) {
        return { success: false, isLimitExceeded: true, productCount: products.length };
    }

    // Add product
    products.push({
        id: productData.id,
        title: productData.title,
        url: productData.url,
        image: productData.image,
        price: productData.price,
        vendor: productData.vendor,
        addedAt: new Date().toISOString(),
    });

    saveComparisonList(products);
    return { success: true, productCount: products.length };
}

function removeFromComparison(productId) {
    const products = getComparisonList();
    const filtered = products.filter((p) => p.id !== productId);
    saveComparisonList(filtered);
    return { success: true, productCount: filtered.length };
}

function isInComparison(productId) {
    const products = getComparisonList();
    return products.some((p) => p.id === productId);
}

function clearComparison() {
    saveComparisonList([]);
    return { success: true, productCount: 0 };
}

function showToast(message, type = 'info') {
    let container = document.querySelector('.toast-container');

    if (!container) {
        container = document.createElement('div');
        container.className = 'toast-container';
        document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;

    const icons = {
        error: '❌',
        warning: '⚠️',
        info: 'ℹ️',
        success: '✅',
    };

    toast.innerHTML = `
        <span class="toast-icon">${icons[type] || icons.info}</span>
        <div class="toast-content">${message}</div>
        <button class="toast-close" aria-label="Close">×</button>
    `;

    container.appendChild(toast);

    const closeBtn = toast.querySelector('.toast-close');
    closeBtn.addEventListener('click', () => {
        removeToast(toast);
    });

    setTimeout(() => {
        removeToast(toast);
    }, 5000);
}

function removeToast(toast) {
    toast.classList.add('toast-hiding');

    setTimeout(() => {
        toast.remove();

        const container = document.querySelector('.toast-container');
        if (container && container.children.length === 0) {
            container.remove();
        }
    }, 300);
}

function isComparisonPage() {
    return (
        window.location.pathname.includes('/pages/product-comparison') ||
        window.location.pathname.includes('/product-comparison') ||
        document.querySelector('#comparison-container') !== null
    );
}

function showPermanentNotificationBar(message, productCount) {
    if (isComparisonPage()) {
        return;
    }

    const notificationBar = document.getElementById('comparison-notification-bar');
    const messageEl = document.getElementById('notification-message');
    const countEl = document.getElementById('notification-count');

    if (!notificationBar || !messageEl || !countEl) return;

    messageEl.textContent = message;
    countEl.textContent = `${productCount} product${productCount > 1 ? 's' : ''} added`;
    notificationBar.style.display = 'block';
}

function showTemporaryNotification(message, productCount) {
    if (isComparisonPage()) {
        return;
    }

    const notificationBar = document.getElementById('comparison-notification-bar');
    const messageEl = document.getElementById('notification-message');
    const countEl = document.getElementById('notification-count');

    if (!notificationBar || !messageEl || !countEl) return;

    messageEl.textContent = message;
    countEl.textContent = `${productCount} product${productCount > 1 ? 's' : ''} added`;
    notificationBar.style.display = 'block';
    notificationBar.style.animation = 'pulse 0.5s ease-in-out';

    setTimeout(() => {
        notificationBar.style.animation = '';
    }, 500);
}

function hideNotificationBar() {
    const notificationBar = document.getElementById('comparison-notification-bar');
    if (notificationBar) {
        notificationBar.style.display = 'none';
    }
}

function checkAndShowPersistentBar() {
    if (isComparisonPage()) {
        return;
    }

    const products = getComparisonList();
    const productCount = products.length;

    if (productCount > 0) {
        showPermanentNotificationBar('Your Products are Ready for Comparison', productCount);
    } else {
        hideNotificationBar();
    }

    updateAllButtonStates();
}

function updateButtonState(button, isInList) {
    if (!button) return;

    const tooltip = button.querySelector('.compare-tooltip');

    if (isInList) {
        button.classList.add('added');
        if (tooltip) tooltip.textContent = 'Added';
    } else {
        button.classList.remove('added');
        // Set appropriate default text based on button type
        if (button.classList.contains('pdp-compare-icon-btn')) {
            if (tooltip) tooltip.textContent = 'Compare';
        } else {
            if (tooltip) tooltip.textContent = 'Add to Compare';
        }
    }
}

function updateAllButtonStates() {
    // Update both PLP and PDP buttons
    const buttons = document.querySelectorAll('.plp-compare-icon-btn, .pdp-compare-icon-btn');

    buttons.forEach((button) => {
        const productId = button.dataset.productId;
        if (productId) {
            const isInList = isInComparison(productId);
            updateButtonState(button, isInList);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {

    // Check for existing products and show persistent notification bar
    checkAndShowPersistentBar();

    // Set up periodic check to maintain bar visibility and button states
    setInterval(checkAndShowPersistentBar, 30000);
});

// Compare button click handler - handles both PLP and PDP buttons
document.addEventListener('click', (e) => {
    const button = e.target.closest('.plp-compare-icon-btn, .pdp-compare-icon-btn');
    if (!button) return;

    const productData = {
        id: button.dataset.productId,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage,
        price: button.dataset.productPrice,
        vendor: button.dataset.productVendor,
    };

    if (!productData.id) {
        showToast('Product ID not found', 'error');
        return;
    }

    const result = addToComparison(productData);

    if (result.success) {
        updateButtonState(button, true);
        showTemporaryNotification(
            `"${productData.title}" added to comparison!`,
            result.productCount
        );
    } else if (result.isLimitExceeded) {
        showToast(
            `Maximum ${MAX_PRODUCTS} products allowed in comparison list. Please remove some products to add new ones.`,
            'warning'
        );
    } else if (result.alreadyAdded) {
        updateButtonState(button, false);
        showToast('This product is removed from your comparison list.', 'info');
    } else {
        showToast('Failed to add to compare', 'error');
    }
});

// View comparison button click handler
document.addEventListener('click', (e) => {
    if (e.target.id === 'view-comparison-btn') {
        window.location.href = '/pages/product-comparison';
    }
});

// Close notification button click handler
document.addEventListener('click', (e) => {
    if (e.target.id === 'close-notification-btn') {
        hideNotificationBar();

        // Store hide preference temporarily
        sessionStorage.setItem('hideCompareBar', Date.now().toString());

        // Show again after 30 seconds if products still exist
        setTimeout(() => {
            const hideTime = sessionStorage.getItem('hideCompareBar');
            if (hideTime && Date.now() - parseInt(hideTime) > 29000) {
                checkAndShowPersistentBar();
            }
        }, 30000);
    }
});

// Handle page visibility change
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        setTimeout(checkAndShowPersistentBar, 1000);
    }
});

// Handle window focus
window.addEventListener('focus', () => {
    setTimeout(checkAndShowPersistentBar, 1000);
});

// Listen for comparison list updates from other tabs/pages
window.addEventListener('comparisonListUpdated', (e) => {
    checkAndShowPersistentBar();
});

// Expose functions globally for use in comparison page
window.ProductComparison = {
    getList: getComparisonList,
    add: addToComparison,
    remove: removeFromComparison,
    isInList: isInComparison,
    clear: clearComparison,
    MAX_PRODUCTS: MAX_PRODUCTS,
};

  // Update buttons when variant changes
 /**
 * Product Action Buttons - Variant Change Handler
 * File: product-action-buttons.js
 * Location: assets/product-action-buttons.js
 */

(function() {
  'use strict';

  // Store observers for cleanup
  const observers = new Map();
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Find all action button containers
    const containers = document.querySelectorAll('[data-availability-actions]');
    
    if (containers.length === 0) {
      console.warn('⚠️ No action button containers found');
      return;
    }

    containers.forEach(container => {
      const sectionId = container.dataset.sectionId;
      
      // Load variant data for this section
      const variantData = loadVariantData(sectionId);
      
      if (!variantData) {
        console.warn('No variant data found for section:', sectionId);
        return;
      }

      // Store data globally for access
      window.productVariantsData = window.productVariantsData || {};
      window.productVariantsData[sectionId] = variantData;

      // Initial update
      updateButtons(container, sectionId);

      // Setup listeners
      setupVariantChangeListeners(container, sectionId);
      setupMutationObserver(container, sectionId);
    });
  }

  function loadVariantData(sectionId) {
    const dataScript = document.querySelector(`script[data-variant-inventory][data-section-id="${sectionId}"]`);
    
    if (!dataScript) {
      console.warn('Variant data script not found for section:', sectionId);
      return null;
    }

    try {
      const data = JSON.parse(dataScript.textContent);
      return data;
    } catch (error) {
      console.error('Error parsing variant data:', error);
      return null;
    }
  }

  function updateButtons(container, sectionId) {

    const testRideButton = container.querySelector('[data-test-ride-button]');
    const reserveButton = container.querySelector('[data-reserve-button]');
    
    if (!testRideButton || !reserveButton) {
      console.warn('Buttons not found in container');
      return;
    }

    // Get current variant ID from the form
    const variantInput = document.querySelector('input[name="id"], select[name="id"]');
    
    if (!variantInput || !variantInput.value) {
      console.warn('Variant input not found or empty');
      return;
    }

    const variantId = variantInput.value;
    const variantsData = window.productVariantsData[sectionId];
    if (!variantsData || !variantsData[variantId]) {
      console.warn('Variant data not found for ID:', variantId);
      return;
    }
    const variantData = variantsData[variantId];
    const isInStock = variantData.isInStock;

    // Show/hide buttons based on stock status
    if (isInStock) {
      testRideButton.style.display = '';
      reserveButton.style.display = 'none';
    } else {
      testRideButton.style.display = 'none';
      reserveButton.style.display = '';
    }
  }

  function setupVariantChangeListeners(container, sectionId) {
    // Listen for various variant change events (same as star icon script)
    const events = ['variant:change', 'shopify:variant:change', 'change'];
    events.forEach(eventName => {
      document.addEventListener(eventName, function(e) {
        // Check if the event is related to variant selection
        if (
          e.target &&
          (e.target.name === 'id' ||
            e.target.classList.contains('product-form__input') ||
            e.target.closest('variant-selects') ||
            e.target.closest('variant-radios'))
        ) {
          setTimeout(() => updateButtons(container, sectionId), 150);
        }
      });
    });
  }

  function setupMutationObserver(container, sectionId) {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    
    if (!productForm) {
      console.warn('Product form not found');
      return;
    }

    // Disconnect existing observer if any
    if (observers.has(sectionId)) {
      observers.get(sectionId).disconnect();
    }

    // Create a new observer to watch for form changes
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;

      mutations.forEach(mutation => {
        // Check if variant input has changed
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          const target = mutation.target;
          if (
            target.name === 'id' ||
            target.closest('variant-selects') ||
            target.closest('variant-radios')
          ) {
            shouldUpdate = true;
          }
        }
      });

      if (shouldUpdate) {
        // Debounce the update
        clearTimeout(window.actionButtonTimeout);
        window.actionButtonTimeout = setTimeout(() => {
          updateButtons(container, sectionId);
        }, 100);
      }
    });

    // Start observing
    observer.observe(productForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked']
    });

    // Store observer for cleanup
    observers.set(sectionId, observer);
  }

  // Cleanup function for theme editor
  document.addEventListener('shopify:section:unload', function(event) {
    const sectionId = event.detail.sectionId;
    
    if (observers.has(sectionId)) {
      observers.get(sectionId).disconnect();
      observers.delete(sectionId);
    }
  });
})();

/**
 * Product Availability - Variant Change Handler
 * File: product-availability.js
 * Location: assets/product-availability.js
 * Updates delivery info based on variant stock status
 */

(function() {
  'use strict';

  const observers = new Map();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const containers = document.querySelectorAll('[data-product-availability]');
    
    if (containers.length === 0) {
      console.warn('No availability containers found');
      return;
    }

    containers.forEach(container => {
      const sectionId = container.dataset.sectionId;
      const availabilityData = loadAvailabilityData(sectionId);
      
      if (!availabilityData) {
        console.warn('No availability data found for section:', sectionId);
        return;
      }

      window.productAvailabilityData = window.productAvailabilityData || {};
      window.productAvailabilityData[sectionId] = availabilityData;

      updateAvailability(container, sectionId);
      setupVariantChangeListeners(container, sectionId);
      setupMutationObserver(container, sectionId);
    });
  }

  function loadAvailabilityData(sectionId) {
    const dataScript = document.querySelector(`script[data-availability-data][data-section-id="${sectionId}"]`);
    
    if (!dataScript) {
      return null;
    }

    try {
      const data = JSON.parse(dataScript.textContent);
      return data;
    } catch (error) {
      console.error('❌ Error parsing availability data:', error);
      return null;
    }
  }

  function updateAvailability(container, sectionId) {
    const deliveryInfo = container.querySelector('[data-delivery-info]');
    const callToCheck = container.querySelector('[data-call-to-check]');
    
    if (!deliveryInfo || !callToCheck) {
      return;
    }

    const variantInput = document.querySelector('input[name="id"], select[name="id"]');
    
    if (!variantInput || !variantInput.value) {
      return;
    }
    const variantId = variantInput.value;
    const availabilityData = window.productAvailabilityData[sectionId];
    if (!availabilityData || !availabilityData[variantId]) {
      return;
    }
    const variantData = availabilityData[variantId];
    const showDelivery = variantData.showDelivery;
    if (showDelivery) {
      deliveryInfo.style.display = '';
      callToCheck.style.display = 'none';
    } else {
      deliveryInfo.style.display = 'none';
      callToCheck.style.display = '';
    }
  }

  function setupVariantChangeListeners(container, sectionId) {
    const events = ['variant:change', 'shopify:variant:change', 'change'];
    events.forEach(eventName => {
      document.addEventListener(eventName, function(e) {
        if (
          e.target &&
          (e.target.name === 'id' ||
            e.target.classList.contains('product-form__input') ||
            e.target.closest('variant-selects') ||
            e.target.closest('variant-radios'))
        ) {
          setTimeout(() => updateAvailability(container, sectionId), 150);
        }
      });
    });
  }

  function setupMutationObserver(container, sectionId) {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    
    if (!productForm) {
      console.warn('Product form not found');
      return;
    }

    if (observers.has(sectionId)) {
      observers.get(sectionId).disconnect();
    }

    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;

      mutations.forEach(mutation => {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          const target = mutation.target;
          if (
            target.name === 'id' ||
            target.closest('variant-selects') ||
            target.closest('variant-radios')
          ) {
            shouldUpdate = true;
          }
        }
      });

      if (shouldUpdate) {
        clearTimeout(window.availabilityTimeout);
        window.availabilityTimeout = setTimeout(() => {
          updateAvailability(container, sectionId);
        }, 100);
      }
    });

    observer.observe(productForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked']
    });

    observers.set(sectionId, observer);
  }

  document.addEventListener('shopify:section:unload', function(event) {
    const sectionId = event.detail.sectionId;
    
    if (observers.has(sectionId)) {
      observers.get(sectionId).disconnect();
      observers.delete(sectionId);
    }
  });
})();